import GlobalConst from "../constants/GlobalConst";

class Money{
    constructor(val, culture){
        this.culture = culture || "en-US";
        if(isNaN(val)) {
            val = parseFloat(val);
        }

        this.value = val || 0;
        this.money = this.value != 0 && this.value ? this.value.toFixed(2) : (0).toFixed(2);
    }

    get K(){

        let kSep = ","
        if (this.culture.includes("fr"))
            kSep = " ";
        return kSep;
    }
    get Dec(){

        let decSep = ".";
        if (this.culture.includes("fr"))
            decSep = ",";
        return decSep;
    }

    toString(noDec){
        var str = "";
        if (isNaN(this.value) || this.value == Infinity)
            str = `0${this.Dec}00`;
        if (this.value > 0 && this.value < 0.01)
            str = `< 0${this.Dec}01`;
        str = this.money.toString()
            .replace('.', this.Dec)
            .replace(/\B(?=(\d{3})+(?!\d))/g, this.K);
        if(noDec)
            str = str.split(this.Dec)[0]
        return str;
    }

    toK(noDec) {
        var str = "";
        if(isNaN(this.value) || this.value == Infinity)
            str=  `0${this.Dec}00`;
        if(this.value > 0 && this.value < 0.01)
            str= `< 0${this.Dec}01`;
        str= this.money >= 1000 ? (this.money/1000).toFixed(1) + 'K' : this.money.toString()
            .replace('.', this.Dec)
            .replace(/\B(?=(\d{3})+(?!\d))/g, this.K);
        if(this.value < 1000 && noDec)
            str = str.split(this.Dec)[0];
        return str;
    }
    toM(){
        if(this.value < 1000000)
            return this.toK();

        if(isNaN(this.value) || this.value == Infinity)
            return `0${this.Dec}00`;

        return (this.money/100000).toFixed(3) + 'M'
    }

    static getCurrencySymbol(currency){
        switch(currency){
            case "MXN":
            case "US":
                return "$";
            case "TF":
                if(GlobalConst.FEATURES.DOTFR)
                    return "€*";
                else
                    return "*$";
            case "CAD":
                return "$";
            case "EUR":
                return "€";
            case "NB_PTS":
                return "€*";
            default:
                if(GlobalConst.FEATURES.DOTFR)
                    return "€";
                else
                    return "$";
        }
    }
    static getCurrency (value, currency) {
        let leftSymbol = null;
        let rightSymbol = null;

        switch(currency){
            case "US":
                leftSymbol = "$";
                break;
            case "TF":
                if(GlobalConst.FEATURES.DOTFR)
                    rightSymbol = "€*";
                else
                    leftSymbol = "*$";
                break;
            case "CAD":
                rightSymbol = "$";
                break;
            case "EUR":
                rightSymbol = "€";
                break;
            default:
                if(GlobalConst.FEATURES.DOTFR)
                    rightSymbol = "€";
                else
                    leftSymbol = "$";
                break;
        }

        let amount = new Money(value).toString();

        return (leftSymbol || "") + amount + (rightSymbol || "")
    }

}

export default Money;
